import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'first'
})
export class FirstPipe implements PipeTransform {
	transform(_value: any, _args?: unknown): any {
		return null;
	}
}
